<template>
    <div class="input-container">
        <textarea
            v-model="text"
            placeholder="Collez ici le texte à analyser..."
            @keydown.enter.exact.prevent="send"/>

        <button
            class="send-button"
            @click="send"
            :disabled="loading">   
            Analyser →
        </button>
    </div>
</template>
    
<script>
   export default {
      props:{
        loading:Boolean
      },
      data(){
        return{
          text:""
        }
      },
      methods:{
        send(){
          if(this.text.trim()==="")
            return;
          this.$emit("send",this.text);
          this.text="";
        }
      }
    }
</script>
    
<style scoped>    
    .input-container{
        position:relative;
        padding:20px;
        background:#17191c;
        border-top:1px solid #2b2e33;
        border-radius: 30px;
    }

    textarea{
        width:100%;
        min-height:80px;
        max-height:220px;
        padding:22px;
        padding-bottom:70px;
        resize:none;
        background:#1f2227;
        border:1px solid #30343a;
        border-radius:18px;
        color:white;
        font-size:12px;
        box-sizing:border-box;
    }

    textarea:focus{
        outline:none;
        border-color:#991b1b;
    }

    .send-button{
        position:absolute;
        right:38px;
        bottom:38px;
        background:#b11d1d;
        color:white;
        border:none;
        border-radius:12px;
        padding:12px 22px;
        cursor:pointer;
        transition:.2s;
    }

    .send-button:hover{
        background:#d32626;
    }
</style>